module.exports = __webpack_public_path__ + "img/plus.28bd1892.svg";